import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'

import $ from 'jquery/src/jquery'
import './design-language-css/dist/design-language.css'
import './index.css'
import 'bootstrap/dist/js/bootstrap.js'

import React from 'react'
import ReactDOM from 'react-dom'
import './twd'
import App from './App'

global.jQuery = global.$ = $

const root = document.getElementById('root')
ReactDOM.render(<App />, root)



// WEBPACK FOOTER //
// ./src/index.js